<template>
  <div>
    <b-card
      no-body
      class="py-2 px-1 container-card"
    >
      <history-privilege-detail
        :reference="privilegeDetail.ref"
        :name-en="privilegeDetail.nameEn"
        :name-th="privilegeDetail.nameTh"
        :image-url="privilegeDetail.image"
      />
      <b-row class="mt-2 px-1">
        <b-col
          cols="12"
          class="px-2 mb-1"
        >
          <div>
            <div class="d-flex flex-wrap justify-content-end">
              <div
                class="search-container mb-1 mb-md-0 mr-0 ml-0 ml-xl-2 ml-lg-1"
              >
                <search :on-search-input="onSetValueSearch" />
              </div>
            </div>
          </div>
        </b-col>
        <b-col
          cols="12"
          class="mb-1"
        >
          <overlay-loading :loading="loading.tableData">
            <template #content>
              <!-- <b-table
                :fields="fields"
                :items="inventoryHistoryTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                no-local-sorting
                class="default-static-table normal-height"
              > -->
              <b-table
                :fields="fields"
                :items="inventoryHistoryTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                no-local-sorting
                class="default-static-table-vertical normal-height"
              >
                <template #cell(seq)="data">
                  <span>{{ data.index + 1 }}</span>
                </template>
                <template #cell(updatedtime)="data">
                  <div>{{ resolveDateWithSeperator(data.value) }}</div>
                </template>
                <template #cell(actions)="data">
                  <icon-detail
                    class="svg-icon"
                    v-b-tooltip.hover
                      title="Detail"
                    @click.native="routeHistoryDetail(data.item)"
                  />
                </template>
                <template #table-busy>
                  <overlay-loading :loading="true" />
                </template>
                <template #empty>
                  <card-no-item :text-no-img="'Item Not Found'" />
                </template>
              </b-table>
            </template>
          </overlay-loading>
        </b-col>
        <b-col
          cols="12"
          class="my-1"
        >
          <pagination-with-reorder
            entity-editable
            :pagination="pagination"
            @entityChange="onFilterEntity"
            @pageChange="onPageChange"
          />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCol,
  BCard,
  BTable,
  BFormCheckbox,
  BRow,
  BSpinner,
} from 'bootstrap-vue'
import CardNoItem from '@core/components/card-no-item/CardNoItem.vue'

import AddButton from '@/views/components/button/AddButton.vue'
import Search from '@/views/components/search/Search.vue'
import vSelect from 'vue-select'
import ManageButton from '@/views/components/button/ManageButton.vue'
import IconDetail from '@/@core/components/svg/common/IconDetail.vue'
import PaginationWithReorder from '@/views/components/pagination/PaginationWithReorder.vue'
import useInventoryHistoryGroup from './hooks/useInventoryHistoryGroup'
import HistoryPrivilegeDetail from './components/HistoryPrivilegeDetail.vue'

export default {
  components: {
    BCol,
    BCard,
    BTable,
    BFormCheckbox,
    BRow,
    BSpinner,
    CardNoItem,
    AddButton,
    Search,
    vSelect,
    ManageButton,
    IconDetail,
    HistoryPrivilegeDetail,
    PaginationWithReorder,
  },
  setup() {
    const {
      fields,
      loading,
      inventoryHistoryTable,
      privilegeDetail,
      pagination,
      routeHistoryDetail,
      onPageChange,
      onSetValueSearch,
      resolveDateWithSeperator,
      onFilterEntity,
    } = useInventoryHistoryGroup()
    return {
      fields,
      loading,
      inventoryHistoryTable,
      privilegeDetail,
      pagination,
      routeHistoryDetail,
      onPageChange,
      onSetValueSearch,
      resolveDateWithSeperator,
      onFilterEntity,
    }
  },
}
</script>

<style scoped>
@import '~@/assets/css/pages/default-static-table.css';
@import '~@/assets/css/override-styles/dynamic-fields.css';
</style>
